import script from "./SiteBeianFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteBeianFooter.vue?vue&type=script&setup=true&lang=js"

import "./SiteBeianFooter.vue?vue&type=style&index=0&id=ae3a2c3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae3a2c3a"]])

export default __exports__